export default "__VITE_ASSET__BYKWBTBZ__"